import * as d3 from "d3";
import { Deployment, foldDeployment } from "./domain/deployment";
import { OrgRating } from "./domain/organization";

export default {
  apiBasePath: (deployment: Deployment) => {
    return `/data/${deployment}`;
  },
  feedUrl: "/feed",

  screenshotServiceBaseUrl: "http://localhost:4000/?url=",

  valueFormat: d3.format(".2f"),
  averageMeasure: d3.mean,

  ratingGroups: [
    {
      name: "top",
      rating: 3 as OrgRating,
    },
    {
      name: "middle",
      rating: 2 as OrgRating,
    },
    {
      name: "low",
      rating: 1 as OrgRating,
    },
  ],

  yearSelectionEnabled: true,

  titleMoreLinks: foldDeployment({
    ch: () => ({}),
    de: () => ({
      audi: {
        href: "/news/18",
      },
      bmw: {
        href: "/news/18",
      },
      daimler: {
        href: "/news/18",
      },
      ford: {
        href: "/news/18",
      },
      bosch: {
        href: "/news/18",
      },
      vw: {
        href: "/news/18",
      },
    }),
  }),
};
